import { QbrowserVisibilityStateEvent } from "./types";

export default class DocumentMonitor {
    private visible = true;

    constructor() {
        if ((window as any).mqq) {
            (window as any).mqq.addEventListener(
                "qbrowserVisibilityChange",
                this.onVisibleChange.bind(this)
            );
        }
    }

    private onVisibleChange(event: QbrowserVisibilityStateEvent): void {
        this.visible = !event.hidden;
    }

    isVisible(): boolean {
        return this.visible && document.visibilityState !== "hidden";
    }
}
